<body style="height:100%;"  class="flex-wrap;">

  <!-- Il s'agit du conteneur de l'en tête -->
  <div id="fond2" class="container-fluid UPSIDE">

    <!-- la ligne contenu par le conteneur d'en tête -->
    <div class="row justify-content-md-center border border-dark ">

      <!-- le contenu de l'en tête diviser en 3 colonne  -->
      <div class="col-3  w-auto p-2 font-weight-bold">
        <p class="modeJN"> {{currentDate | date:'yyyy-MM-dd'}}  </p>
      </div>

      <div class="col-6 text-center w-auto p-2 font-weight-bold">
        <span class="modeJN">DASHBOARD ETUDIANT</span>
        <a href="#"></a>

        <label class="switch align-middle">
          <input type="checkbox" (click)="etatMode()" id="buttonMode">
          <div class="slider"></div>
        </label>

      </div>

      <div class="col-3 w-auto p-2 text-right font-weight-bold">
        <span class="modeJN">  Mon compte : MG </span>
      </div>

    </div>
  </div>

  <!-- ###################################################### -->

  <!-- Il s'agit du conteneur du dashboard en soit  -->
  <div id="fond" class="container-fluid DOWNSIDE" style="height:100%;">

    <!-- la ligne contenu par le conteneur du dashboard -->
    <div class="row justify-content-md-center" style="height:100%;">

      <!-- le contenu du dashboard diviser en 3 colonne  -->
      <div class="col-4  w-auto p-2 " style="max-height:100vh;">

        <!-- On va mettre içi le bloc: EMPLOI DU TEMPS | MES MAILS | EMPRUNT BIBLIOTHEQUE -->

        <!-- EMPLOI DU TEMPS -->
        <div class="container EMPLOI DU TEMPS bordure-de-template mb-1" style="background-color:#C2B714">

          <!-- Partie superieur avec emploi du temps et le date picker -->
          <app-date-search></app-date-search>

        </div>
        <!-- FIN EMPLOI DU TEMPS  -->


        <!-- MES MAILS -->
        <div class="container MES MAILS bordure-de-template mb-1" style="background-color:#A43EF0">

          <!-- Partie superieur avec mes mails et la barre de recherche -->
         <app-search [appareilName] = "mails"></app-search>

        </div>
        <!-- FIN MES MAILS  -->


        <!-- EMPRUNT BIBLIOTHEQUE -->
        <div class="container EMPRUNT BIBLIOTHEQUE bordure-de-template mb-1" style="background-color:#C23868">

        <app-simple [appareilName] = "emprunts"></app-simple>

        </div>
        <!-- FIN EMPRUNT BIBLIOTHEQUE  -->

      </div>
      <!-- FIN DE LA PREMIERE COLONNE  -->



      <!-- ICI ON A LA DEUXIEME COLONNE AVEC MES COURS SEULEMENT  -->
      <div class="col-4 w-auto p-2">
        <!-- MES COURS -->
        <div class="container MES COURS bordure-de-template mb-1" style="background-color:#A410C2">

          <!-- Partie superieur avec mes mails et la barre de recherche et les radios button de filtre -->
          <app-button-search></app-button-search>

        </div>
        <!-- FIN MES COURS  -->
      </div>
      <!-- FIN DE LA DEUXIEME COLONNE AVEC MES COURS SEULEMENT  -->



      <!-- LA TROISIEME COLONNE AVEC MES COURS SEULEMENT  -->
      <div class="col-4 w-auto p-2" style="max-height:100vh">

        <!-- On va mettre içi le bloc: CONTACT | MES DOCUMENTS | IZLY+PAPERCUT+PARAMETRE -->

        <!-- CONTACT -->
        <div class="container CONTACT bordure-de-template mb-1" style="background-color:#406BC2">

          <!-- Partie superieur avec mes mails et la barre de recherche -->
          <app-simple [appareilName] ="contact"></app-simple>

        </div>
        <!-- FIN CONTACT  -->


        <!-- MES DOCUMENTS -->
        <div class="container MES DOCUMENTS bordure-de-template mb-1" style="background-color:#06C216">

          <!-- Partie superieur avec mes mails et la barre de recherche -->
          <app-search [appareilName] = "docs"></app-search>

        </div>
        <!-- FIN MES DOCUMENTS  -->

        <!-- ON GERE IZLY PAPERCUT ET PARAMETRE -->
        <div class="container col-12 IZLY PAPERCUT PARAMETRE mb-1 flex">

          <!-- Ligne du conteneur -->
          <div class="row">

            <!-- 1er colonne de gauche pour IZLY et PAPERCUT -->
            <div class="col-5 p-0 mr-4">

              <div class="col-12 justify-content-md-center IZLY p-0 ">

                <div class="col-12 bordure-de-template mb-4 mr-1" style="background-color:#DCDCDC">
                <app-solde [appareilName] = "izly"></app-solde>
                </div>                  

                <div class="col-12 bordure-de-template  mr-1" style="background-color:#DCDCDC">
                  <app-solde [appareilName]="papercut"></app-solde>
                </div>

              </div>

            </div>

            <!-- 2eme colonne de gauche pour PARAMETRE -->

            <div class="col-6 m-0 p-0 ml-1">
                  <app-img></app-img>
            </div>


          </div>
          <!-- fin ligne conteneur -->

        </div>
        <!-- fin conteneur IZLY PAPERCUT ET PARAMETRE  -->


      </div>
      <!-- FIN DELA TROISIEME COLONNE AVEC MES COURS SEULEMENT  -->

    </div>
    <!-- FIN DE LA LIGNE 'DOWNSIDE' DU DASHBOARD  -->



  </div>
  <!-- FIN DU CONTENEUR DOWNSIDE DU DASHBOARD -->
  <style media="screen">
    .bordure-de-template{
      border-style:solid;
      border-width: 3px;
    }

    
  
    #imageBouton{
      border: none;
      background-color: transparent;
      outline: none;
    }
  
    #imageBouton:active{
      border: none;
      background-color: transparent;
      outline: none;
    }
  
    #imageBouton:focus{
      border: none;
    }
  
    #datepicker{
      background-image: url('/../assets/calendar.png');
      background-Position : 99% center;
      background-Repeat :no-repeat;
      cursor:pointer;
    }
  
    /* Pour le bouton nuit jour : */
    .switch {
      position: relative;
      display: inline-block;
      width: 60px;
      height: 34px;
    }
  
    .switch input {display:none;}
  
    .slider {
      position: absolute;
      cursor: pointer;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: #ccc;
      -webkit-transition: .4s;
      transition: .4s;
    }
  
    .slider:before {
      position: absolute;
      content: "";
      height: 26px;
      width: 26px;
      left: 4px;
      bottom: 4px;
      background-color: white;
      -webkit-transition: .4s;
      transition: .4s;
    }
  
    input:checked + .slider {
      background-color: #5ba02e;
    }
  
    input:focus + .slider {
      box-shadow: 0 0 1px #5ba02e;
    }
  
    input:checked + .slider:before {
      -webkit-transform: translateX(26px);
      -ms-transform: translateX(26px);
      transform: translateX(26px);
    }
  
  
    /* Pour la barre de recherche  */
    * {
      box-sizing: border-box;
    }
  
    .barreRecherche {
      background-image: url('/../assets/search.png');
      background-position: 10px 12px;
      background-repeat: no-repeat;
      width: 100%;
      font-size: 16px;
      padding: 12px 20px 12px 40px;
      border: 1px solid #ddd;
      margin-bottom: 12px;
    }
  
    .listeRecherche {
      list-style-type: none;
      padding: 0;
      margin: 0;
    }
  
    .listeRecherche li a { /*J'ai commenter parce que c'était pas jolie visuellement*/
    /* border: 1px solid #ddd;
    margin-top: -1px; *//* evite une double bordure */
    /* background-color: #f6f6f6;
    padding: 12px;
    text-decoration: none;
    /* font-size: 18px;*/
    color: black;
    /*display: block */
  }
  
  .listeRecherche li a:hover:not(.header) {
    color: red;
  }

  
  
  </style>

  
  </body>
<router-outlet></router-outlet>